// Shape of the sampling handoff between the admin pipeline and the
// public /electionday readout.
//
// Persisted in Postgres (table `electionday_state`, row kind='sampling',
// payload jsonb). The public page reads via
// /api/electionday-state?kind=sampling (edge-cached). All mutations
// are admin-side, gated by verifySession (see
// api/admin/electionday-sampling.ts).
//
// `Batch` is re-exported here as the canonical shape so neither side
// has to import from the stats module to know the wire format. The
// stats module's own Batch alias points back at this one to keep the
// definitions in lockstep.

export interface Batch {
  /** Maltese district label — "District 1" through "District 13", or
   *  the editor's "TBC" placeholder while a batch is in flight. The
   *  public StatsPanel ignores TBC; only district-tagged batches
   *  enter the national rollup. */
  district: string;
  /** Clean PL reads in this batch. */
  pl: number;
  /** Clean PN reads in this batch. */
  pn: number;
  /** Stills that did NOT yield a clean read (OTHER, UNREADABLE,
   *  medium / low confidence, or failed rectify). */
  abstained: number;
}

export interface ElectionDaySamplingState {
  /** Snapshot of every batch the admin has committed since the last
   *  reset. The public page reads this as the authoritative tally. */
  committedBatches: Batch[];
  /** Last-touched timestamp for the document (debug aid). */
  updatedAt: string;
}

export function emptySamplingState(): ElectionDaySamplingState {
  return {
    committedBatches: [],
    updatedAt: new Date().toISOString(),
  };
}
